import { render, staticRenderFns } from "./EmployeePlatforms.vue?vue&type=template&id=9706f342&scoped=true"
import script from "./EmployeePlatforms.vue?vue&type=script&lang=js"
export * from "./EmployeePlatforms.vue?vue&type=script&lang=js"
import style0 from "./EmployeePlatforms.vue?vue&type=style&index=0&id=9706f342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9706f342",
  null
  
)

export default component.exports